import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";
import CheckIcon from "@mui/icons-material/Check";
import { bindActionCreators } from "redux";
import { filterDomainsForComponent } from "../../utils";
import "./MultiSelectStyles.css";
import { Actions } from "../../Action/index";
import { useLocation } from "react-router-dom";
import { Home_PAGE_URL } from "../../Router/routerUrl";

const customStyles = {
  // menu: (provided) => ({
  //   ...provided,
  //   zIndex: 9999,
  // }),

  control: (base) => ({
    ...base,
    height: 29,
    minHeight: 29,
    marginBottom: 5,
    borderColor: "lightgray",
    // width: "120px",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    color: "lightgray",
  }),
  clearIndicator: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    color: "lightgray",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isFocused
      ? "#f6f7f8"
      : state.isSelected?'#f6f7f8':"none",
    color: state.isFocused ||state.isSelected ? "#5c647a" : "#5C667B",
  }),
};

const ValueContainer = ({ children, ...props }) => {
  let [values, input] = children;
  if (Array.isArray(values)) {
    const plural = values.length === 1 ? "" : "s";
    values = `${values.length} selected`;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

// Hover and selected currently share the same background color, so a
// selected option is indistinguishable from one you're just hovering over.
// A checkmark (same color as the clear "X") makes the selected state
// readable regardless of hover.
const Option = (props) => {
  const { children, isSelected } = props;
  return (
    <components.Option {...props}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span>{children}</span>
        {isSelected && (
          <CheckIcon
            style={{
              color: "lightgray",
              fontSize: "16px",
              marginLeft: "8px",
            }}
          />
        )}
      </div>
    </components.Option>
  );
};

export default function MultiSelectCm({
  value,
  onChangeFunc,
  isMulti,
  options,
  disabled,
  placeholder="Select",
 isClearable=false
}) {
  const userData = useSelector((state) => state.user);
  let [option, setOptions] = useState(options);
  const onChangeSelectedOption = (value) => {
    // onChangeFunc(value);
    onChangeFunc(value || []);
  };

  const currentPath = useLocation();
  useEffect(() => {}, []);
  return (
    <>
      <Select
        className={"multiselect3"}
        onChange={onChangeSelectedOption}
        placeholder={placeholder}
        options={options}
        isMulti={isMulti}
        value={value}
        components={{ ValueContainer, Option }}
        closeMenuOnSelect={!isMulti}
        styles={customStyles}
        hideSelectedOptions={false}
        isDisabled={disabled}
        maxMenuHeight={150}
        isClearable={isClearable}
      />
    </>
  );
} 
